// extracted by mini-css-extract-plugin
export default {"nav":"MainMenu_nav__IovW5","nav__label":"MainMenu_nav__label__MipMu","nav__list":"MainMenu_nav__list__wdNPW"};